import { useLocation } from 'react-router-dom';
import { shouldOfferConsent } from '../../lib/analyticsConsent';
import { useAnalyticsConsent } from '../../hooks/useAnalyticsConsent';
import { ConsentChoices } from './ConsentChoices';

/**
 * Non-blocking card, only on /parents and /pricing. Shown when no choice is saved,
 * and kept visible while there is a status message (e.g. storage refused to save).
 */
export function ConsentCard() {
  const {
    pathname
  } = useLocation();
  const snapshot = useAnalyticsConsent();
  if (!shouldOfferConsent(pathname)) return null;
  const needsChoice = snapshot.choice === 'unset' && !snapshot.signalDenied;
  if (!needsChoice && !snapshot.message) return null;
  return <section aria-labelledby="consent-card-title" className="fixed inset-x-3 bottom-3 z-40 max-h-[80vh] overflow-y-auto rounded-2xl border-2 border-ink bg-cream p-5 shadow-lift sm:inset-x-auto sm:bottom-5 sm:right-5 sm:w-[420px]" data-id="element-98" data-mp="30tc41816qe7h">
      <h2 id="consent-card-title" className="mb-3 font-display text-[22px] leading-tight text-ink" data-id="element-99" data-mp="39uteoavtpnos">
        Optional website analytics
      </h2>
      <ConsentChoices snapshot={snapshot} data-id="element-100" data-mp="249oiarmqfzrj" />
    </section>;
}